<template>
  <el-form-item :class="{ 'is-required': required }" :label="label" :prop="prop" v-bind="$attrs">
    <ny-select class="is-large" v-model="currentValue" :data="data" :filterable="filterable" v-bind="$attrs">
      <slot slot="ny:item" name="ny:item" slot-scope="item" v-bind="item"></slot>
    </ny-select>
  </el-form-item>
</template>

<script>
import NySelect from '../select'

export default {
  name: 'NyFormItemSelect',
  components: {
    NySelect
  },
  props: {
    value: {
      required: true
    },
    required: Boolean,
    label: String,
    prop: String,
    data: {
      type: Array,
      default: () => []
    },
    filterable: Boolean
  },
  data () {
    return {
      currentValue: this.value
    }
  },
  watch: {
    value (newVal) {
      this.currentValue = newVal;
    },
    currentValue (value) {
      this.currentValue = value
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>
